/**
 * Safari-specific drawer configurations for MUI Drawer components
 * This utility provides consistent drawer behavior across all browsers, especially Safari
 */

export const getSafariCompatibleDrawerSx = (width = 600) => ({
  boxShadow: "none",
  "& .MuiDrawer-paper": { 
    boxShadow: "none",
    width: `${width}px !important`,
    maxWidth: `${width}px !important`,
    transform: "translateX(0) !important",
    transition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important",
    "@media (max-width: 600px)": {
      width: "100% !important",
      maxWidth: "100% !important"
    },
    // Safari-specific fixes
    WebkitTransform: "translateX(0) !important",
    WebkitTransition: "transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important",
    // Force hardware acceleration for Safari
    WebkitBackfaceVisibility: "hidden",
    WebkitPerspective: "1000px",
    // Prevent Safari from applying full width
    position: "fixed !important",
    right: "0 !important",
    left: "auto !important",
    height: "100% !important",
    overflow: "auto"
  },
  // Additional Safari fixes for the drawer container
  "& .MuiBackdrop-root": {
    WebkitBackfaceVisibility: "hidden",
    WebkitPerspective: "1000px"
  }
});

export const getSafariCompatibleBoxSx = () => ({
  width: "100%",
  height: "100%",
  overflow: "auto",
  // Safari-specific fixes for the content box
  WebkitOverflowScrolling: "touch",
  WebkitTransform: "translateZ(0)",
  position: "relative"
});

/**
 * Enhanced drawer props with Safari compatibility
 */
export const getSafariCompatibleDrawerProps = (anchor = "right", open, onClose, width = 600) => ({
  anchor,
  open,
  onClose,
  ModalProps: {
    BackdropProps: {
      style: { backgroundColor: "rgba(0, 0, 0, 0.1)" },
    },
  },
  sx: getSafariCompatibleDrawerSx(width)
});

/**
 * Enhanced box props with Safari compatibility
 */
export const getSafariCompatibleBoxProps = (onClick, onKeyDown) => ({
  sx: getSafariCompatibleBoxSx(),
  role: "presentation",
  onClick,
  onKeyDown
});
